// extracted by mini-css-extract-plugin
module.exports = {"value":"DivisionPicker_value_1TIY1","item":"DivisionPicker_item_2nY-C"};